import script from "./xshzList.vue?vue&type=script&setup=true&lang=js"
export * from "./xshzList.vue?vue&type=script&setup=true&lang=js"

import "./xshzList.vue?vue&type=style&index=0&id=0fc28aeb&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc28aeb"]])

export default __exports__